(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["footer-newsletter"] && !Shopify.designMode) return;
  try {
    function bindFooterNewsletterFeedback() {
  const form = document.getElementById('newsletter-footer');
  if (!form || form.dataset.feedbackBound) return;
  form.dataset.feedbackBound = 'true';
  const status = form.querySelector('[role="status"]');
  const button = form.querySelector('button[type="submit"]');
  let timer;
  const showProgress = () => {
    if (!form.checkValidity()) return;
    clearTimeout(timer);
    status.textContent = status.dataset.waiting;
    timer = setTimeout(() => { status.textContent = status.dataset.slow; }, 15000);
  };
  button.addEventListener('click', showProgress);
  form.addEventListener('submit', showProgress);
  form.addEventListener('input', () => {
    clearTimeout(timer);
    status.textContent = '';
  });
  window.addEventListener('pageshow', () => {
    clearTimeout(timer);
    status.textContent = '';
  });
}
bindFooterNewsletterFeedback();
document.addEventListener('shopify:section:load', bindFooterNewsletterFeedback);
  } catch(e) { console.error(e); }
})();

})();
